import { useEffect, useState } from 'react';
import { IHandleStartRegistrationProps } from 'types/ui/Registration';
import { authApiClient } from 'utils/apiClient';
import { APP_ENDPOINT } from 'utils/constants';
import HttpStatusCode from 'utils/HttpStatusCode';
import useScript from 'utils/useScript';

export const useAppleSignIn = (
  handleSuccessfulLogin: (token: string, name: string) => Promise<void>,
  handleStartRegistration: (
    props: IHandleStartRegistrationProps
  ) => Promise<void>,
  setError: (error?: string) => void
) => {
  const [isAppleLoading, setisAppleLoading] = useState<boolean>(false);

  const [scriptLoaded] = useScript(
    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js'
  );
  useEffect(() => {
    if (scriptLoaded) {
      // @ts-ignore
      window.AppleID?.auth.init({
        clientId: 'uk.co.daymade.signin',
        scope: 'name email',
        redirectURI: `https://${APP_ENDPOINT}/register`,
        usePopup: true,
      });
    }
  }, [scriptLoaded]);

  const doAppleSignIn = async () => {
    setisAppleLoading(true);

    try {
      // @ts-ignore
      const data = await window.AppleID?.auth.signIn();
      console.log('Apple login success:', data);

      const loginResponse = await authApiClient.public.loginWithApple({
        body: { accessToken: data.authorization.id_token },
      });

      if (loginResponse.status === HttpStatusCode.OK) {
        await handleSuccessfulLogin(
          loginResponse.body.token,
          loginResponse.body.welcomeName
        );
      } else {
        setError(loginResponse.body.message);
      }
    } catch (err) {
      console.error('Apple login error:', err);
    }
    setisAppleLoading(false);
  };

  const doAppleRegister = async () => {
    setisAppleLoading(true);

    try {
      // @ts-ignore
      const data = await window.AppleID?.auth.signIn();

      const appleIdToken = data.authorization.id_token;
      const result = await authApiClient.public.validateAppleAccessToken({
        body: { accessToken: appleIdToken },
      });

      if (result.status === HttpStatusCode.BAD_REQUEST) {
        setError(result.body.message);
        console.error(result.body.message);
        return;
      } else if (result.status === HttpStatusCode.OK) {
        handleSuccessfulLogin(result.body.token, result.body.welcomeName);
        return;
      }

      const validatedAppleUserId = result.body.appleUserId;

      handleStartRegistration({
        appleUserId: validatedAppleUserId,
        email: result.body.appleEmailAddress ?? '',
        firstName: data?.user?.name.firstName ?? '',
        lastName: data?.user?.name.lastName ?? '',
      });

      console.log('Apple login success:', data);
    } catch (err) {
      setError('Apple login error');
      console.error('Apple login error:', err);
    }
    setisAppleLoading(false);
  };

  return { isAppleLoading, doAppleSignIn, doAppleRegister };
};
